import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {MatSidenavModule} from "@angular/material/sidenav";
import {RouterOutlet} from "@angular/router";
import {ClickEventService} from '../../../../utils/services/click-event.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';
import {NgClass} from '@angular/common';
import {DocumentationSidenavComponent} from '../documentation-sidenav/documentation-sidenav.component';
import {FooterComponent} from '../../../base/components/footer/footer.component';

@Component({
  selector: 'app-documentation-wrapper',
  imports: [
    MatSidenavModule, RouterOutlet, NgClass,
    DocumentationSidenavComponent, FooterComponent
  ],
  templateUrl: './documentation-wrapper.component.html',
  styleUrl: './documentation-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentationWrapperComponent implements OnInit, OnDestroy {
  private readonly clickEventService: ClickEventService = inject(ClickEventService);
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  isSmallScreen = false;
  isOpen = true;
  private clickEventSubscription?: Subscription;
  private breakpointSubscription?: Subscription;

  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isSmallScreen = result.matches;
        this.isOpen = !this.isSmallScreen;
        this.cdr.detectChanges();
      });

    this.clickEventSubscription = this.clickEventService.clickSideNavEvent$.subscribe(() => {
      this.isOpen = !this.isOpen;
      this.cdr.detectChanges();
    });

    this.clickEventService.trackSubscription(this.clickEventSubscription);
  }

  ngOnDestroy(): void {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }
}
